import { render, staticRenderFns } from "./PIcon.vue?vue&type=template&id=56d99f94&scoped=true"
import script from "./PIcon.vue?vue&type=script&lang=ts"
export * from "./PIcon.vue?vue&type=script&lang=ts"
import style0 from "./PIcon.vue?vue&type=style&index=0&id=56d99f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d99f94",
  null
  
)

export default component.exports